import React from 'react';
import ArticleFetcher from "../articleFetcher";
import {galleryArticles} from "../articles";
import {Helmet} from "react-helmet";
import analyticsDataToDB from "../../comp-analyticsLog/dbLogging";

export default class BlogArticleSix extends React.Component {

  constructor(props) {
    super(props);
    var article = galleryArticles.article6;
    this.state = {
      category: article.category,
      hashTags: article.hashTags,
      title: article.title,
      subtitle: article.subtitle,
      photos: article.photos,
      contents: article.contents,
      thumbnail: article.thumbnail,
    }
  }

  componentDidMount(){
    this.logToDbUserRecord();
  }

  logToDbUserRecord() {
    analyticsDataToDB("fetch-article", "article-6-acid-free-matboard-meaning");
  }


  render() {
    return <div className={`gallery-container`}>

      <Helmet>
        <title>What does acid-free mat board mean? • Custom Mat Board </title>
        <meta name="description" content="What does acid-free mat board mean? Should I use an acid free mat board? What does acid free mean? See our technical definition of acid free mat board."/>
      </Helmet>

      <ArticleFetcher article={this.state}/>
    </div>
  }
}